import Index from '@/views/apps/inputOutputAdjust/Index.vue'
import Adjust from '@/views/apps/inputOutputAdjust/Adjust.vue'
import RandomInventory from '@/views/apps/randomInventory/Index.vue'
import layouts from '@/layout'

export default {
	path: 'adjust',
	name: 'Documentos',
	auth: true,
	component: Index,
	redirect: { path: '/adjust', name: 'Ajustes' },
	icon: 'file',
	meta: {
		auth: true,
		nav: true,
		roles: ['admin', 'deposit']
	},
	children: [
		{
			path: '/adjust_input',
			name: 'Entrada',
			component: Adjust,
			meta: {
				// 1 = Entrada y 2 = Salida
				type: 1,
				typeDocument: 7,
				auth: true,
				nav: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['Ajuste', 'Entrada'],
				roles: ['admin', 'deposit'],
				icon: 'bank-transfer-in'
			}
		},
		{
			path: '/adjust_output',
			name: 'Salida',
			component: Adjust,
			meta: {
				// 1 = Entrada y 2 = Salida
				type: 2,
				typeDocument: 8,
				auth: true,
				nav: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['Ajuste', 'Salida'],
				roles: ['admin', 'deposit'],
				icon: 'bank-transfer-out'
			}
		},
		{
			path: '/random_inventory',
			name: 'Toma de inventario',
			component: RandomInventory,
			meta: {
				auth: true,
				nav: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['Inventario', 'Ramdom', 'Aleatorio'],
				roles: ['admin', 'deposit'],
				icon: 'inventory'
			}
		},
		{
			path: '/adjust_output1',
			name: 'Traslado',
			component: Adjust,
			meta: {
				// 1 = Entrada y 2 = Salida
				type: 2,
				typeDocument: 3,
				auth: true,
				nav: false,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['Traslado', 'Salida', 'Entrada'],
				roles: ['admin', 'deposit'],
				icon: 'bank-transfer'
			}
		},
	]
}
